import { useAcceptOrganizationInvitation } from "@/api";
import { Button } from "@/components/ui/button";
import { LoadingCircle } from "@/components/ui/loadingCircle";
import { toast } from "@/components/ui/use-toast";
import { useNavigate, useSearch } from "@tanstack/react-router";

type Props = {
  invitationId: string;
};

export const AcceptInvitation = ({ invitationId }: Props) => {
  const navigate = useNavigate();
  const { redirect } = useSearch({ from: "/_auth/invitation/$invitationId" });
  const [acceptInvitation, { loading }] = useAcceptOrganizationInvitation();

  return (
    <div className="flex items-center gap-2 relative">
      <Button
        data-testid="organizationInvitationAcceptButton"
        disabled={loading}
        onClick={() => {
          acceptInvitation({ variables: { invitationId } })
            .then((res) => {
              if (
                res.data?.organizationInvitationAccept?.__typename ===
                "Organization"
              ) {
                toast({
                  title: "Organization invitation accepted",
                  description: `You are now part of the organization ${res.data.organizationInvitationAccept.name}`
                });
                if (redirect) navigate(redirect);
                else
                  navigate({
                    to: "/organization/$organizationSlug/gallery",
                    params: {
                      organizationSlug:
                        res.data.organizationInvitationAccept.slug
                    }
                  });
              } else if (
                res.data?.organizationInvitationAccept?.__typename ===
                "OrganizationNotFound"
              ) {
                toast({
                  title: "Organization invitation error",
                  description:
                    "The organization invitation could not be accepted, please try again."
                });
              }
            })
            .catch(() => {
              toast({
                title: "Unknown error",
                description: "An unknown error happened, please try again."
              });
            });
        }}
      >
        Accept
      </Button>
      {loading && <LoadingCircle className="absolute -right-7" />}
    </div>
  );
};
